import { render, staticRenderFns } from "./TestCardEdit.vue?vue&type=template&id=e0abd15e&"
import script from "./TestCardEdit.vue?vue&type=script&lang=js&"
export * from "./TestCardEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports